export default "__VITE_ASSET__D3qQHt7d__"